import React from 'react';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';

const Fashion = () => {
    return (
        <div className="w-full">
            <Header />
            <div className="w-full bg-[#FEEEDE] flex items-center justify-center h-[60vh]">
                <h1 className="font-dang text-[#FE9ECE] text-with-border text-[14vw] md:text-[6vw] text-center leading-tight">
                    Coming<br />soon
                </h1>
            </div>
            <Footer />
        </div>
    );
};

export default Fashion;
